import { useContext } from 'react';
import { ContentContext } from '../../contexts/ContentContext';
import useContent from '../../hooks/useContent';
import useUnsavedChanges from '../../hooks/useUnsavedChanges';
import AdminTopbar from '../AdminTopbar';
import SaveBar from '../components/SaveBar';

export default function HeroEditor() {
  const { content, updateSection } = useContext(ContentContext);
  const { draft, isDirty, saving, lastSaved, update, save, discard } =
    useContent(content.hero);
  useUnsavedChanges(isDirty);

  const handleSave    = () => save(patch => updateSection('hero', patch));
  const handleDiscard = () => discard(content.hero);

  return (
    <div className="adm-page">
      <AdminTopbar title="Hero" />
      <SaveBar isDirty={isDirty} saving={saving} lastSaved={lastSaved}
               onSave={handleSave} onDiscard={handleDiscard} />

      <div className="adm-editor">
        <section className="adm-section">
          <h3 className="adm-section__title">Headline</h3>

          <div className="adm-field">
            <label className="adm-label">Label (eyebrow text)</label>
            <input className="adm-input" value={draft.label || ''}
              onChange={e => update({ label: e.target.value })} />
          </div>

          <div className="adm-field">
            <label className="adm-label">Headline Line 1</label>
            <input className="adm-input" value={draft.headline1 || ''}
              onChange={e => update({ headline1: e.target.value })} />
          </div>

          <div className="adm-field">
            <label className="adm-label">Headline Line 2</label>
            <input className="adm-input" value={draft.headline2 || ''}
              onChange={e => update({ headline2: e.target.value })} />
          </div>

          <div className="adm-field">
            <label className="adm-label">Subtext</label>
            <textarea className="adm-textarea" rows={3} value={draft.subtext || ''}
              onChange={e => update({ subtext: e.target.value })} />
          </div>

          <div className="adm-field">
            <label className="adm-label">Trust Text (below buttons)</label>
            <input className="adm-input" value={draft.trustText || ''}
              onChange={e => update({ trustText: e.target.value })} />
          </div>
        </section>

        <section className="adm-section">
          <h3 className="adm-section__title">Buttons</h3>

          <div className="adm-row-2">
            <div className="adm-field">
              <label className="adm-label">Primary Button Label</label>
              <input className="adm-input" value={draft.btn1Label || ''}
                onChange={e => update({ btn1Label: e.target.value })} />
            </div>
            <div className="adm-field">
              <label className="adm-label">Primary Button URL</label>
              <input className="adm-input" value={draft.btn1Url || ''}
                onChange={e => update({ btn1Url: e.target.value })} />
            </div>
          </div>

          <div className="adm-row-2">
            <div className="adm-field">
              <label className="adm-label">Secondary Button Label</label>
              <input className="adm-input" value={draft.btn2Label || ''}
                onChange={e => update({ btn2Label: e.target.value })} />
            </div>
            <div className="adm-field">
              <label className="adm-label">Secondary Button URL</label>
              <input className="adm-input" value={draft.btn2Url || ''}
                onChange={e => update({ btn2Url: e.target.value })} />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
